/**
 * @typedef {import('../../../mpro/plugins/jquery.autocomplete').default} Autocomplete
 * @typedef {import('../../../mpro/plugins/jquery.autocomplete').AutocompleteOptions} AutocompleteOptions
 * @typedef {{ drawerInstance?: import('../../../modules/components/drawer').default }} EnhanceOptions
 */

/**
 * @type {AutocompleteOptions}
 */
// @ts-ignore
const autocompleteDefaults = {
	searchOnInit: true,
	setSelectionOnBlur: false,
	minChars: 2,
	delay: 366,
	sgWidth: 'auto',
	sgResizeFn: (sgContElement, inputElement, rect) => {
		sgContElement.style.minWidth = mpro.isMobileScreen() ? 'auto' : `${Math.round(rect.right - rect.left)}px`;
	},

	sgClassContainer: 'ss-results',
	sgClassSuggestion: 'ss-results__item',
	sgClassSelected: 'ss-results__item--selected',
	sgClassText: 'ss-results__text',
	sgClassHighlight: 'ss-results__highlight',

	termReplaceRules: mpro.getRegexAutocompleteTerm,

	/** @type {(this: Autocomplete) => void} */
	onInit() {
		const { minChars } = this.options;
		const { $input } = this.refs;
		const $btnClear = this.refs.$btnClear = $input.siblings('.search__button-clear, .search-inline__button-clear');

		const toggleIcon = (input) => {
			if (input.value.length >= minChars) {
				$btnClear.removeClass('search__button-clear--none search-inline__button-clear--none');
			}
			else {
				$btnClear.addClass('search__button-clear--none search-inline__button-clear--none');
			}
		};

		// Add binding to the clear button
		$btnClear.on('click', (e) => {
			$input.val('').trigger('change');
		});

		$input.on('input change', () => void toggleIcon($input[0]));
		toggleIcon($input[0]);
	},

	// onSearchSuggest: function (items) {
	// 	if (!items || !items.length) {
	// 		this.searchSuggest({}, {
	// 			term: this.lastSearch.term,
	// 			items: [{
	// 				id: 0,
	// 				text: JS_LANG_VARS.txt_no_results,
	// 				addClass: 'p-05 text-center',
	// 				selectable: false
	// 			}]
	// 		});
	// 		return false;
	// 	}
	// },

	onSelectItem($item) {
		// const itemData = $item.data();
		const item = $item[0];
		const url = item.dataset.url || item.dataset.href;

		if (url) {
			mpro.setLocation(url);
		}
		return void 0;
	},

	onXhrStart() {
		this.refs.$btnClear.addClass('search-inline__button-clear--loading');
	},

	onXhrComplete() {
		this.refs.$btnClear.removeClass('search-inline__button-clear--loading');
	},

	// xhrPromiseHandler: (term) => {
	// 	return [
	// 		data => {
	// 			debugger;
	// 			return [];
	// 		},
	// 	];
	// }
};

/**
 * @param {JQuery} $container
 * @param {EnhanceOptions=} options
 */
export const enhanceSearchForm = ($container, options = {}) => {

	// Change the form action
	/** @type {JQuery<HTMLFormElement>} */
	// @ts-ignore
	let $forms = $container.find('form');

	if ($forms.length === 0) {
		// @ts-ignore
		$forms = $container.filter('form');
	}

	for (const formElement of $forms) {

		/** @type {JQuery<HTMLFormElement>} */
		// @ts-ignore
		const $form = $(formElement);

		/** @type {JQuery<HTMLInputElement>} */
		// @ts-ignore
		const $input = $form.find('input[data-search-input]');

		// Make sure the form submits to a custom path
		if (($input.length > 0) && $input[0].name) {
			const formUrl = new URL($form.attr('action') || document.URL);
			const path = formUrl.pathname.split('/');
			path.push($input.attr('name'));
			$input.val(mpro.config.env.search_string);

			$form.on('submit', (e) => {
				e.preventDefault();

				const val = String($input.val());
				// Prevent form submission (and other form handlers) if no value is set
				if (!val) {
					e.stopImmediatePropagation();
					e.stopPropagation();
					return;
				}

				const url = new URL('', formUrl);
				const newPath = [...path, encodeURIComponent(val)];
				url.pathname = newPath.join('/');
				mpro.setLocation(url.toString(), { loaderOptions: { delay: 0 } });
			});
		}

		// Enable remote autocomplete
		if ($input.is('[data-search-autocomplete]') && !$input.is('[data-search-autocomplete="false"]')) {
			enableAutocomplete($input, options);
		}
	}
};

/**
 * @param {JQuery<HTMLInputElement>} $input
 * @param {EnhanceOptions=} options
 */
export const enableAutocomplete = async ($input, options = {}) => {

	// Lazy import the plugin
	const { 'default': Autocomplete } = await import('../../../mpro/plugins/jquery.autocomplete');

	// Only if not already initialized
	if (!Autocomplete.getInstance($input[0])) {

		const data = $input.data();
		const autocompleteArgs = data.autocompleteArgs || null;
		/** @type {Map<string, JQuery>} */
		const acParams = new Map;

		if (autocompleteArgs) {
			for (const [field, elementId] of Object.entries(autocompleteArgs)) {
				acParams.set(field, $(`#${elementId}`));
			}
		}

		const ac = new Autocomplete($input[0], {
			...autocompleteDefaults,

			// Place the results container overlay at the bottom of the drawer
			// sgTop: instance.getElement().getBoundingClientRect().bottom,
			sgLeft: () => (mpro.isMobileScreen() ? 'auto' : null),
			sgRight: () => (mpro.isMobileScreen() ? 'auto' : null),
			sgWidth: () => (mpro.isMobileScreen() ? '100vw' : 'fill'),

			remote: {
				url: data.searchUrl,
				/** @type {(term: string) => {[key: string]: string}|{}} */
				data(term) {
					if (acParams.size > 0) {
						const data = {};
						for (const [field, $elem] of acParams) {
							const val = $elem.val();
							if (val !== '' && val != null) {
								data[field] = val;
							}
						}
						return data;
					}
					return { q: term };
				},
				method: 'GET',
			},
		});

		const instance = options.drawerInstance;

		if (instance) {
			// Dirty hack to calculate the drawer height
			$(instance.getElement()).one('shown.bs.offcanvas', function(e) {
				const drawerElement = this;

				// Display the result window starting where the drawer bottom margin ends
				ac.options.sgPosition = 'fixed';
				ac.options.sgTop = instance.getElement().getBoundingClientRect().bottom - 1;
				ac.options.sgMaxHeight = () => `calc(100vh - ${drawerElement.offsetHeight}px)`;
			});
		}

		$input.on('destroy', () => {
			acParams.clear();
		});
	}
};
